<template>
  <div>
    <div class="menu__header">
      <img
        src="../../assets/logo.png"
        alt="Logo"
        @click="changeLanguage(currentLocale)"
      >
      <div class="header-buttons">
        <a
          class="header-btn"
          :href="t('website-link')"
        >{{
          t("Visit our Website")
        }}</a>
        <a
          class="header-btn"
          :href="t('contact-us-mail')"
        >{{
          t("Contact Us")
        }}</a>

        <div class="dropdown">
          <div
            class="dropdown-btn"
            @click="changeLanguage(currentLocale)"
          >
            <span>{{ currentLocale.toUpperCase() }}</span>
            <v-icon size="small">
              mdi-chevron-down
            </v-icon>
          </div>

          <ul>
            <li
              v-for="lang in dropdownLanguages"
              :key="lang"
              @click="changeLanguage(lang)"
            >
              <span>{{ lang.toUpperCase() }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="banner__header">
      <div class="banner-container">
        <div class="headline">
          {{ t("myCeGaT Portal") }}
        </div>
        <div
          class="welcome-header"
          v-html="t('Place your order easily and digital')"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import i18n from '@/plugins/i18n'
import { supportedLanguages } from '@/utils/language'
import { useRouter, useRoute } from 'vue-router'

const router = useRouter()
const route = useRoute()
const { t } = useI18n()
const currentLocale = ref(i18n.global.locale.value)

const languages = supportedLanguages

const dropdownLanguages = computed(() =>
  languages.filter(lang => lang !== currentLocale.value)
)

function changeLanguage(lang: string) {
  currentLocale.value = lang;
  i18n.global.locale.value = lang;
  router.replace({ query: { ...route.query, _lang: lang } })
}

</script>

<style lang="scss">
.menu__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 5rem;
  margin: auto;
  width: 66.67vw;

  img {
    margin-left: -0.563rem;
    height: 3.75rem;
    cursor: pointer;
  }

  .header-buttons {
    display: flex;
    gap: 1.25rem;
    height: 100%;

    .header-btn {
      align-self: center;
      border: 1px solid rgb(var(--v-theme-blue));
      border-radius: 3px;
      color: rgb(var(--v-theme-blue));
      font-size: 1.125rem;
      font-weight: 300;
      padding: 0.625rem 1.875rem;
      text-decoration: none;
      text-align: center;

      &:hover {
        transition: all 0.2s;
        background-color: rgb(var(--v-theme-blue));
        color: rgb(var(--v-theme-white));
      }
    }
  }

  .dropdown {
    font-size: 1.125rem;
    position: relative;
    display: flex;
    color: rgba(var(--v-theme-link-black), var(--v-main-opacity));
    cursor: pointer;

    .dropdown-btn {
      align-self: center;
    & i {
      font-size: 20px;
    }
    }

    a {
      color: inherit;
      text-decoration: none;
    }

    &:hover {
      transition: all 0.2s;
      color: rgb(var(--v-theme-black));

      ul {
        display: block;
      }
    }

    ul {
      display: none;
      position: absolute;
      background-color: rgb(var(--v-theme-white));
      border-radius: 3px;
      margin-top: 5rem;
      list-style: none;

      li {
        padding: 0.75rem 1.25rem;

        &:hover {
          background-color: #f9f9fb;
        }
      }
    }

    .v-icon.v-icon {
      color: rgb(var(--v-theme-link-black));

      &:hover {
        transition: all 0.2s;
        color: rgb(var(--v-theme-black));
      }
    }
  }
}

.banner__header {
  background-color: rgb(var(--v-theme-header-bg));
  padding: 0.75rem;

  .banner-container {
    width: 66.67vw;
    margin: auto;
  }

  .headline {
    margin-top: 2rem;
    color: rgb(var(--v-theme-blue));
    font-size: 2.875rem;
  }

  .welcome-header {
    font-weight: 300;
    color: rgb(var(--v-theme-blue));
    margin-bottom: 3.5rem;
    font-size: 1.5rem;
  }
}

.menu__header, .banner__header {
  line-height: normal;
}

@media #{map.get($display-breakpoints, 'sm-and-down')} {
  .menu__header {
    max-width: 100%;
  }

  .banner__header .banner-container {
    max-width: 100%;
  }
}
</style>
